import { cnpj, cpf } from 'cpf-cnpj-validator'
import { DateTime } from 'luxon'

const valid = require('card-validator')

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}
export const limitParcel = value => {
  if (value >= 0 && value <= 12) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[(){}\[\]\+\-\=_.,:;?!@#\$%\^&\*]).{8,}$/
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  const numberValidation = valid.number(creditnum)
  return numberValidation.isValid
}
export const ValidatorDueDate = val => {
  const year = parseInt(val.slice(0, 4))
  const month = parseInt(val.slice(5, 7))
  const day = parseInt(val.slice(8, 10))
  const date = new Date()

  if (date.getFullYear() > year) return false
  if (date.getFullYear() == year && month < date.getMonth() + 1) return false
  if (date.getFullYear() == year && month == date.getMonth() + 1 && date.getDate() >= day) return false
  return true
}

export const ValidatorBornDate = val => {
  if (!val) return 'A data de nascimento é obrigatória'

  let year, month, day

  if (val.includes('/')) {
    if (val.length !== 10) return 'Data incompleta'
    day = parseInt(val.slice(0, 2))
    month = parseInt(val.slice(3, 5))
    year = parseInt(val.slice(6, 10))
  } 
  else if (val.includes('-')) {
    year = parseInt(val.slice(0, 4))
    month = parseInt(val.slice(5, 7))
    day = parseInt(val.slice(8, 10))
  } else {
    return 'Formato de data inválido'
  }

  const dateObj = new Date(year, month - 1, day)
  if (
    dateObj.getFullYear() !== year ||
    dateObj.getMonth() !== month - 1 ||
    dateObj.getDate() !== day
  ) {
    return 'Digite uma data de nascimento válida'
  }

  const today = new Date()
  if (dateObj > today) return 'A data não pode ser no futuro'


  let age = today.getFullYear() - year
  const m = (today.getMonth() + 1) - month
  if (m < 0 || (m === 0 && today.getDate() < day)) {
    age--
  }

  if (age < 10) {
    return 'Você deve ter mais de 10 anos'
  }

  if (age > 130) {
    return 'A idade máxima permitida é 130 anos'
  }

  return true 
}

export const validatorFees = fees => {
  let juros = fees.toString().replace(',', '.')
  juros = parseFloat(juros.split('%')[0])
  if (juros > 7 || juros < 0) return false
  return true
}

export const validatorDocument = document => {
  const arRegex = /^(\d{2}\.{1}\d{3}\.\d{3})|(\d{2}\s{1}\d{3}\s\d{3})$/
  if (document.length === 10) return arRegex.test(document)
  if (document.length === 14) return cpf.isValid(document)
  if (document.length === 18) return cnpj.isValid(document)
  return false
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorPDF = file => file.type === 'application/pdf'

export const validatorPhone = phone => {
  const regex = /^\(\d{2,}\) \d{4,}-\d{4}/
  const validPhone = regex.test(phone)
  return validPhone
}

export const validatorDate = (year, monthArray) => {
  const month = monthArray[0]
  const date = new Date()

  if (date.getFullYear() === year && month <= date.getMonth() + 1) {
    return false
  }
  return true
}

export const validatorDateRecurrence = val => {
  const date = new Date(val)
  const today = new Date()
  const threeDaysAhead = new Date(today)
  threeDaysAhead.setDate(today.getDate() + 3)
  const dateFormat = date.toISOString().slice(0, 10)
  const threeDaysAheadFormat = threeDaysAhead.toISOString().slice(0, 10)
  return dateFormat >= threeDaysAheadFormat
}

export const validatorCEP = (cep, address) => {
  const city = address[0]
  const regex = /^\d{5}-\d{3}$/
  if (!regex.test(cep)) return false

  if ((city == undefined)) {
    return true
  }
  if (city == ' undefined') {
    return true
  }

  return true
}

export const validatorValue = async value => {
  let valueTotal = value.toString().replace(',', '.')
  valueTotal = valueTotal.replace('R$ ', '')
  valueTotal = parseFloat(valueTotal)

  if (valueTotal > 0) return true
  return false
}

export const validatorCVV = cvv => {
  const regex = /^[0-9]{3,4}$/
  return regex.test(cvv)
}

export const validatorCheckbox = check => {
  if (check) return true
  return false
}

export const validatorRecurrenceDate = (firstChargeDate, validateDate) => {
  validateDate = DateTime.fromISO(validateDate).plus({ days: 3 })
  validateDate = DateTime.fromISO(validateDate).toFormat('yyyy-MM-dd')
  return validateDate < firstChargeDate
}

export const validatorRecurrenceDateFinal = firstChargeDate => {
  const day = firstChargeDate.split('-')[2]
  if (day == 29 || day == 30 || day == 31) return false
  return true
}

export const validatorRecurrenceValue = value => {
  // covert R$ #,## in #.##
  value = value.replaceAll('.', '')
  value = value.replaceAll(',', '.')
  value = parseFloat(value.replace('R$ ', ''))

  // check value is most then 10
  if (value < 10) { return false }

  return true
}

export const validatorBinLocked = (value, { locked }) => {
  if (!locked) return true

  const clean = (value || '').replace(/\D/g, '')

  if (clean.length < 6) return true

  const allowedBin = '375180'

  return clean.startsWith(allowedBin)
}
